import {makeAdUrl} from '@frontend/helpers'
import type {AdPreviewDataForList} from '@frontend/modules/public/ads/AdsModuleTypes'
import {AdPreviewPhotosSwiper} from '@frontend/modules/public/ads/components/list/AdPreviewPhotosSwiper'
import {AdsListItemIcons} from '@frontend/modules/public/ads/components/list/AdsListItemIcons'
import {mdiFire} from '@mdi/js'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {useEventCallback} from 'swayok-react-mdb-ui-kit/helpers/useEventCallback'
import {AnalyticsEventReporter} from '../../../../../helpers/AnalyticsEventReporter'

interface AdsListItemImageAndIconsProps {
    ad: AdPreviewDataForList
}

// Картинка и иконки для карточки предпросмотра объявления в списке.
export function AdsListItemImageAndIcons(props: AdsListItemImageAndIconsProps) {

    const {
        ad,
    } = props

    // Обработчик нажатия на ссылку объявления.
    const onClick = useEventCallback(() => {
        AnalyticsEventReporter.clickOnAdFromList(ad)
    })

    return (
        <div className="flex-center">
            <Link
                className={clsx(
                    'offered-item-card-title mb-2 text-center fw-500',
                    'd-sm-none',
                    'd-md-inline',
                    'd-lg-none'
                )}
                target="_blank"
                to={makeAdUrl(ad.id)}
                rel="noreferrer"
                onClick={onClick}
            >
                {ad.title}
            </Link>
            <div className="offered-item-card-image-and-icons position-relative">
                <AdsListItemIcons
                    ad={ad}
                    liked={ad.isFavourite}
                    // Отображается отдельно.
                    discounted={false}
                />
                {ad.isPromoted && (
                    <div className="offered-item-card-promoted-label bg-orange rounded-end ps-1 pe-2 fs-7 with-icon-flex fw-500 text-dark">
                        <Icon
                            path={mdiFire}
                            size={20}
                            color="dark"
                        />
                        HOT!
                    </div>
                )}
                <AdPreviewPhotosSwiper ad={ad} />
                {ad.photos.length > 0 && (
                    // Для поисковиков.
                    <img
                        src={ad.photos[0]}
                        className="position-absolute opacity-0"
                        width={1}
                        height={1}
                        alt={ad.title}
                    />
                )}
            </div>
        </div>
    )
}
